//@ts-check
import { renderAllSections } from './js-utils-rendersection.js'
import { initB2bQuantityPricing } from './js-c-b2b-quantity-pricing.js'

class CVariantsSelect extends HTMLElement {
  constructor() {
    super()
    /** @type {HTMLLinkElement[]|null} */
    this.linkVariants = Array.from(this.querySelectorAll('[data-variants]'))
    this.btnSticky = [...document.querySelectorAll('.product-btn-sticky')]
    this.selectHead = this.querySelector('[data-open-select]')
    /** @type {HTMLElement|null} */
    this.selectBody = this.querySelector('[data-body-select]')
    this.sectionsRender = [
      {
        title: `${this.btnSticky[0].id}`,
        selector: ['[data-render-btn-sticky]'],
      },
      {
        title: `${this.btnSticky[1].id}`,
        selector: ['[data-render-btn-sticky]'],
      },
      {
        title: 'product',
        selector: [
          '[data-render-price]',
          '[data-render-quantity]',
          '[data-render-btn-add-product]',
          '[data-render-panel-contact]',
          '[data-render-panel-product]',
        ],
      },
    ]
  }

  connectedCallback() {
    this.selectHead?.addEventListener('click', () => {
      this.selectHead?.classList.toggle('is-active')
      if (!this.selectBody) return
      if (this.selectBody.style.maxHeight) {
        this.selectHead?.setAttribute('aria-expand', 'false')

        this.selectBody.style.maxHeight = ''
        this.selectBody.setAttribute('hidden', '')
      } else {
        this.selectHead?.setAttribute('aria-expand', 'true')
        this.selectBody.removeAttribute('hidden')
        this.selectBody.style.maxHeight = this.selectBody.scrollHeight + 'px'
      }
    })
    this.linkVariants?.forEach((link) => {
      link.addEventListener('click', async (e) => {
        e.preventDefault()
        const url = new URL(link.href)
        await this.handleChangeVariant(url)
      })
    })
  }
  async handleChangeVariant(url) {
    history.pushState('', '', `${url.href}`)
    await renderAllSections(this.sectionsRender, url)
    initB2bQuantityPricing()
  }
  disconnectedCallback() {}
}
if (!customElements.get('c-variants-select')) {
  customElements.define('c-variants-select', CVariantsSelect)
}
